import React from 'react';

const EmployeeSuperAdmin = () => {
    return (
        <div>
            {/* Introduction */}
            <h3 style={{ fontSize: "20px", fontWeight: "400", color: "#000000", marginTop: "20px", marginBottom: "10px" }}>
            Details required to add new employee?
            </h3> 
            <p className="description">
                This section provides a detailed explanation of managing employee data, including adding a new employee, viewing the list of employees, and editing an existing one.
            </p>

            {/* Employee List Section */}
            <h3 className="subheading">Employee List</h3>
            <div className="table-wrapper">
                <table className="employee-table">
                    <thead>
                        <tr>
                            <th>S.NO</th>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>Email</th>
                            <th>Phone No</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1</td>
                            <td>John</td>
                            <td>Doe</td>
                            <td>john.doe@example.com</td>
                            <td>1234567890</td>
                            <td><button>Edit</button></td>
                        </tr>
                    </tbody>
                </table>
            </div>

            {/* Employee Table Screenshot */}
            <img
                className="placeholder-image image_gatnix_support"
                src=" https://res.cloudinary.com/danfpnuui/image/upload/v1740691835/WhatsApp_Image_2025-02-26_at_9.37.22_PM_6_bcvbqx.jpg"
                alt="Employee Table Screenshot"
            />

            {/* Add Employee Section */}
            <h3 className="subheading">Add Employee</h3>
            <p className="description">
                Click on the "Add Employee" button to open the form. This form allows you to fill in details like First Name, Last Name, Email, Password, Mobile Number, and WhatsApp Number. Click <strong>Save</strong> to add the employee.
            </p>

            {/* Edit Employee Section */}
            <h3 className="subheading">Edit Employee</h3>
            <img
                className="placeholder-image image_gatnix_support"
                src=" https://res.cloudinary.com/danfpnuui/image/upload/v1740691781/WhatsApp_Image_2025-02-27_at_10.29.53_PM_2_bdbt6d.jpg"
                alt="Edit Employee Screenshot"
            />
            <p className="description">
                Click the "Edit" button to modify an employee's details. A form will appear pre-filled with the existing details. After making changes, click <strong>Save</strong> to update the information.
            </p>

            {/* Save or Cancel Section */}
            <h3 className="subheading">Save or Cancel</h3>
            <p className="description">
                Once the form is filled, click <strong>Save</strong> to submit or <strong>Cancel</strong> to discard the changes.
            </p>

            {/* Notes Section */}
            <h3 className="subheading">Notes</h3>
            <p className="description">
                <li> All mandatory fields must be filled before saving. </li>
                <li>Ensure all contact details are correct. </li>
                <li>Click <strong>Save</strong> to confirm or <strong>Cancel</strong> to discard the changes.</li>
            </p>

            {/* Styles */}
            <style jsx>{`
                /* Text Styling */
                .heading {
                    font-size: 24px;
                    font-weight: 300;
                    color: #000000;
                    margin-bottom: 10px;
                }

                .description {
                    font-size: 16px;
                    line-height: 1.6;
                    color: #4f4f4f;
                    margin-bottom: 20px;
                }

                .subheading {
                    font-size: 20px;
                    font-weight: 300;
                    color: #000000;
                    margin-bottom: 10px;
                }

                /* Table Styling */
                .table-wrapper {
                    overflow-x: auto;
                }

                .employee-table {
                    width: 100%;
                    border-collapse: collapse;
                    margin-bottom: 20px;
                }

                .employee-table th,
                .employee-table td {
                    border: 1px solid #ddd;
                    padding: 8px;
                    text-align: left;
                }

                /* Responsive Design */
                @media (max-width: 768px) {
                    .heading {
                        font-size: 20px;
                    }

                    .subheading {
                        font-size: 18px;
                    }

                    .description {
                        font-size: 14px;
                    }

                    .employee-table th,
                    .employee-table td {
                        font-size: 14px;
                        padding: 6px;
                    }
                }

                @media (max-width: 480px) {
                    .heading {
                        font-size: 18px;
                    }

                    .subheading {
                        font-size: 16px;
                    }

                    .description {
                        font-size: 12px;
                    }

                    .employee-table th,
                    .employee-table td {
                        font-size: 12px;
                        padding: 4px;
                    }
                }
            `}</style>
        </div>
    );
};

export default EmployeeSuperAdmin;
